export const getEnvironment = (): 'prod' | 'dev' | 'qa' => {
  const host = window.location.host;

  if (host.includes('testzz.ninja')) {
    return 'qa';
  }

  if (host.includes('devopzz.ninja') || host.includes('localhost')) {
    return 'dev';
  }

  return 'prod';
};
